// ユーザーデータ操作
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/firestore'
//import ProductData from "@/js/ProductData.js";
//import ProductIdList from "@/js/ProductData.js";
import { SizeList, MaterialList } from "@/js/Const.js";
import { APIConnect } from "@/js/APIConnect.js";
// import { Common } from "@/js/common.js";
// import { from } from 'core-js/fn/array';
import { RealtimeDatabaseTableName } from "@/js/Const.js";


class User {

    static getFBUserData() {
        return new Promise(function (resolve) {
            var ref = firebase
                .database()
                .ref("ShipUser/" + firebase.auth().currentUser.uid);
            ref.once("value", function (snapshot) {
                let list = snapshot.val() ? snapshot.val() : []
                resolve(list)
            })
        })
    }

    /**
     * 
     * @returns FireStore上のAcryProのユーザーデータ
     */
    static getFBAcryProUserData() {
        return new Promise(function (resolve) {
            var ref = firebase
                .database()
                .ref("AcryProUser/" + firebase.auth().currentUser.uid);
            ref.once("value", function (snapshot) {
                let list = snapshot.val() ? snapshot.val() : []
                resolve(list)
            }).catch(() => {
                resolve(null)
            })
        })
    }
    /**
     * ユーザーの情報をサーバに登録
     * @param {ユーザーデータ} userData 
     */
    static registFBAcryProInfo(userData) {
        return new Promise(function (resolve, reject) {
            var ref = firebase
                .database()
                .ref("AcryProUser/" + firebase.auth().currentUser.uid);
            ref.set(userData).then(() => {
                resolve()
            }).catch(() => {
                reject()
            })
        })
    }

    static updateFBAcryProInfo(data) {
        return new Promise(function (resolve, reject) {
            var ref = firebase
                .database()
                .ref("AcryProUser/" + firebase.auth().currentUser.uid);
            ref.update(data).then(() => {
                resolve()
            }).catch(() => {
                reject()
            })
        })
    }

    /*
    タグ関連
    */

    /**
     * タグセット追加
     * @param {}} productId 
     * @param {*} templateName 
     */
    static addTemplate(productId, templateName) {
        let registTagList = []
        let d = MaterialList[productId]
        var tagRef = firebase
            .database()
            .ref("TagData/" + firebase.auth().currentUser.uid);
        for (let key in d) {
            let tagData = {}
            for (let s in SizeList) {
                tagData["templateName"] = templateName
                tagData["productId"] = productId
                tagData["material"] = key
                tagData["size"] = SizeList[s].sizeId
                registTagList.push(tagData)
                tagRef.push(tagData)
            }
        }
        // テンプレートも登録
        var templateRef = firebase
            .database()
            .ref("TagTemplateData/" + firebase.auth().currentUser.uid);
        templateRef.push(
            {
                "productId": productId,
                "templateName": templateName
            }
        )
    }
    static deleteTemplate(state, productId, templateName) {
        // let registTagList = []
        // let d = ProductTagInfoList[productId]
        // var tagRef = firebase
        //     .database()
        //     .ref("TagData/" + firebase.auth().currentUser.uid);
        // console.log("d" + ProductTagInfoList)
        // for (let key in d) {
        //     d[key].forEach((size) => {
        //         // firebaseに登録
        //         let tagData = {}
        //         tagData["templateName"] = templateName
        //         tagData["productId"] = productId
        //         tagData["color"] = key
        //         tagData["size"] = size
        //         registTagList.push(tagData)
        //         tagRef.push(tagData)
        //     })
        // }
        // テンプレート削除
        for (let key in state.userTagTemplateList) {

            if (state.userTagTemplateList[key]["templateName"] == templateName &&
                state.userTagTemplateList[key]["productId"] == productId) {
                let templateRef = firebase
                    .database()
                    .ref("TagTemplateData/" + firebase.auth().currentUser.uid).child(key);
                templateRef.remove()
            }
        }
        for (let key in state.userTagList) {
            let data = state.userTagList[key];
            if (
                data["templateName"] == templateName &&
                data["productId"] == productId
            ) {
                let templateRef = firebase
                    .database()
                    .ref("TagData/" + firebase.auth().currentUser.uid).child(key);
                templateRef.remove()
            }
        }
    }
    static updateTagData(state, productId, templateName, size, material, fileName) {
        for (let key in state.userTagList) {
            let data = state.userTagList[key]
            if (data["material"] == material &&
                data["size"] == size &&
                data["templateName"] == templateName &&
                data["productId"] == productId) {
                data["fileName"] = fileName
                if (!data["count"]) {
                    data["count"] = 1
                } else {
                    data["count"] += 1
                }
                var tagRef = firebase
                    .database()
                    .ref("TagData/" + firebase.auth().currentUser.uid);
                let updates = {}
                updates[key] = data
                tagRef.update(updates)
                return
            }
        }
        // ない場合は追加する
        var ref = firebase
            .database()
            .ref("TagData/" + firebase.auth().currentUser.uid);
        ref.push({
            material: material,
            size: size,
            templateName: templateName,
            productId: productId,
            fileName: fileName
        })
    }


    static generateUuid() {
        let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
        for (let i = 0, len = chars.length; i < len; i++) {
            switch (chars[i]) {
                case "x":
                    chars[i] = Math.floor(Math.random() * 16).toString(16);
                    break;
                case "y":
                    chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
                    break;
            }
        }
        return chars.join("");
    }

    /**
     * ユーザーの情報をサーバに登録
     * @param {ユーザーデータ} userData 
     */
    static registInfo(userData) {
        return new Promise(function (resolve, reject) {

            APIConnect.A02({
                ...userData,
            }).then(function (result) {
                User.userData = userData
                var ref = firebase
                    .database()
                    .ref("ShipUser/" + firebase.auth().currentUser.uid);
                ref.set({
                    isAgent: false
                })
                resolve(result)
            }).catch(function (error) {
                reject(error)
            })
        })
    }

    /**
     * 配送先リストの取得
     */
    static getDestinationList() {
        return APIConnect.B01()
    }

    /**
     * 送付先の追加
     * @param {ユーザーデータ} userData 
     */
    static addDestination(userData) {
        return new Promise(function (resolve, reject) {
            userData['other_deliv_id'] = "0"
            APIConnect.B02({
                ...userData,
            }).then(function (result) {
                resolve()
                console.log(result)
            }).catch(function (error) {
                reject(error)
            })
        })
    }
    /**
    * 送付先の変更
    * @param {ユーザーデータ} userData 
    */
    static editDestination(userData) {
        return new Promise(function (resolve, reject) {
            APIConnect.B02({
                ...userData,
            }).then(function (result) {
                resolve()
                console.log(result)
            }).catch(function (error) {
                reject(error)
            })
        })
    }
    /**
         * 送付先の削除
         */
    static deleteDestination(userData) {
        return new Promise(function (resolve, reject) {
            APIConnect.B03({
                ...userData,
            }).then(function (result) {
                resolve()
                console.log(result)
            }).catch(function (error) {
                reject(error)
            })
        })
    }
    /**
     * ユーザーの情報をサーバから取得
     */
    static getInfo() {
        return new Promise(function (resolve, reject) {
            APIConnect.A01({
            }).then(function (result) {
                User.userData = result
                resolve(result)
            }).catch(function (error) {
                reject(error)
            })
        })
    }
    /**
     * パートナーコードの認証
     * @param partnerCode 
     */
    static authPartnerCode(code) {
        return APIConnect.A03(code)
    }

    /**
     * 注文
     * @param {注文商品リスト} productList 
     * @param {総額など} otherData 
     */
    static orderProduct(productList, otherData, paymentType ) {

        return APIConnect.C02(productList, otherData, paymentType)
    }

    static orderComplete( orderId ) {
        return APIConnect.C05(orderId)
    }

    static orderCoupon(productList, otherData, paymentType ) {

        return APIConnect.C07(productList, otherData, paymentType)
    }

    static orderStatus( orderId ) {
        return APIConnect.C08( orderId )
    }

    /**
     * 注文後の処理
     * @param {}} orderProducts 
     * @param {*} orderId 
     */
    static registHistoryOrderId(orderProducts, orderId, bikou = "") {
        console.log("registHistoryOrderId");
        return new Promise((resolve) => {
            var ref = firebase.database().ref(RealtimeDatabaseTableName.HistoryData + "/" + firebase.auth().currentUser.uid);
            ref.once("value", function (snapshot) {
                /* ここに取得したデータを用いた何らかの処理 */
                let products = []
                if (snapshot.val()) {
                    products = snapshot.val()
                }
                for (let p in products) {
                    for (let o in orderProducts) {
                        if (orderProducts[o].id == products[p].historyId) {
                            products[p].orderId = orderId
                            products[p].bikou = bikou
                        }
                    }
                }
                ref.set(products)
                resolve()
            })
        })
    }

    /**
     * 見積発行の処理
     * @param {}} orderProducts 
     * @param {*} estimatesId 
     */
    static registEstimatesId(orderProducts, estimatesId, destData) {
        return new Promise((resolve) => {
            var ref = firebase.database().ref('EstimatesData/' + firebase.auth().currentUser.uid);
            ref.once("value", function (snapshot) {
                /* ここに取得したデータを用いた何らかの処理 */
                let products = []
                if (snapshot.val()) {
                    products = snapshot.val()
                }
                for (let p in products) {
                    for (let o in orderProducts) {
                        if (orderProducts[o].id == products[p].historyId &&
                            !products[p].estimatesId) {

                            products[p].estimatesId = estimatesId
                            products[p].totalPrice = destData.totalPrice
                            products[p].delivPrice = destData.delivPrice
                            products[p].productPrice = destData.productPrice
                            products[p].taxPrice = destData.taxPrice
                            products[p].otherDelivId = destData.other_deliv_id
                            products[p].issueDate = destData.issueDate
                            products[p].quantity = orderProducts[o].quantity
                            products[p].title = `${orderProducts[o].getProductTitle()} / ${orderProducts[o].productName} / [${orderProducts[o].categoryData.classcategory_name1} * ${orderProducts[o].categoryData.classcategory_name2} ] `
                            products[p].price = orderProducts[o].getOnePrice() + orderProducts[o].getOneMarginPrice()
                        }
                    }
                }
                ref.set(products)
                resolve()
            })
        })
    }
    /**
     * 注文履歴
     * @param {ORDER_DATE:注文日,SHIPPING:発送日,ORDER_CONFIRM_DATE:注文確定日} type 
     * @param {*} fromDate 
     * @param {*} toDate 
     */
    static getOrderHistory(type, fromDate, toDate, orderId = "") {

        var order_date_from = ""
        var order_date_to = ""
        var commit_date_from = ""
        var commit_date_to = ""
        var payment_date_from = ""
        var payment_date_to = ""

        switch (type) {
            case 'ORDER_DATE':
                order_date_from = fromDate ? fromDate : ""
                order_date_to = toDate ? toDate : ""
                break
            case 'SHIPPING':
                commit_date_from = fromDate ? fromDate : ""
                commit_date_to = toDate ? toDate : ""
                break
            case 'ORDER_CONFIRM_DATE':
                payment_date_from = fromDate ? fromDate : ""
                payment_date_to = toDate ? toDate : ""
                break
        }
        return APIConnect.C01({
            order_date_from: order_date_from,
            order_date_to: order_date_to,
            commit_date_from: commit_date_from,
            commit_date_to: commit_date_to,
            payment_date_from: payment_date_from,
            payment_date_to: payment_date_to,
            order_id: orderId,
        })
    }

    static receiptDownload(orderId) {
        return APIConnect.C03(orderId)
    }

    /**
     * パスワードの更新空で解除
     * @param {パスワード} password 
     */
    static updatePassword(password) {

        return new Promise((resolve) => {
            User.userData["password"] = password
            var ref = firebase
                .database()
                .ref("ShipUser/" + firebase.auth().currentUser.uid);
            ref.set({
                isAgent: false,
                password: password
            })
            resolve()
        })
    }



    static sendRequest(userData) {
        return APIConnect.A04(userData)
    }

    static checkSignature(xid) {
        return APIConnect.A05(xid)
    }

    static resendRequest(xid) {
        return APIConnect.A06(xid)
    }

    static sendVerificationEmail(email) {
        return APIConnect.A07(email)
    }

    static sendPasswordResetEmail(email) {
        return APIConnect.A08(email)
    }

}
export { User }
